import {useField, useFormikContext} from 'formik';
import React, {ReactElement, ReactNode} from 'react';
import InputMask from 'react-input-mask';
import {isFieldRequired, useValidationSchema} from '../form/ValidationService';
import {NxFormikInputProps} from '../nxInput/NxFormikInput';
import NxInput from '../nxInput/NxInput';
import {MOBILE_NUMBER_MASK} from './NxPhoneInput';

export type NxFormikPhoneInputProps = Omit<NxFormikInputProps, 'type'> & {
  mask?: string;
}

export const NxFormikPhoneInput = (props: NxFormikPhoneInputProps): ReactElement => {

  const context = useFormikContext();
  const [field, meta, ] = useField(props);
  const validationSchema = useValidationSchema();
  const required = props.required || isFieldRequired(validationSchema, field.name);
  const disabled = props.disabled || context.isSubmitting;

  /**
   * InputMask passes down every prop except the following ones:
   * onChange, onPaste, onMouseDown, onFocus, onBlur, value, disabled, readOnly.
   */
  return (
    <InputMask {...props} {...field} disabled={disabled} mask={props.mask ?? MOBILE_NUMBER_MASK} maskChar={''}>
      {
        (inputProps: NxFormikInputProps): ReactNode =>
          <NxInput {...inputProps} type="tel" error={meta.error} disabled={disabled} required={required} />
      }
    </InputMask>
  );
}
